function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import useStyles from './use_styles';
import Tooltip from '../tooltip/tooltip';
import useTableContext from '../table/use_table_context';
import useDirection from '../direction/use_direction';
import { DEFAULT_MIN_WIDTH, DEFAULT_WIDTH } from '../table/defaults';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TableResizer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var _tableHeadRef$current, _tableBodyRef$current, _tooltipContent$curre;
  var {
    component: Component = 'div',
    headerOffset = 0,
    id,
    initialTooltipWidth
  } = _ref;
  var {
    hasFilters,
    i18n,
    isColumnResizing,
    onResizeColumn,
    resizeWidths,
    setResizeWidths,
    showResizeTooltip,
    tableBodyRef,
    tableHeadRef,
    tableWrapperRef,
    theme,
    widths
  } = useTableContext();
  var defaultMinWidth = hasFilters ? DEFAULT_WIDTH : DEFAULT_MIN_WIDTH;
  var {
    isRTL
  } = useDirection();
  var [lineState, setLineState] = React.useState('default');
  var movementStarted = React.useRef(false);
  var tooltipContent = React.useRef();
  var resizeWidth = React.useRef();
  var a11yAria = React.useRef({
    valueMax: '10000',
    valueMin: "".concat(defaultMinWidth),
    valueText: "".concat(tooltipContent.current || initialTooltipWidth)
  });
  var resizingColumnID = resizeWidths.findIndex(obj => obj.id === id);
  var minMaxWidth = widths === null || widths === void 0 ? void 0 : widths.find(obj => obj.columnId === id);
  var updateResizeWidths = React.useCallback((state, bool, newResizeWidth) => {
    setResizeWidths(prevWidths => {
      var resizeWidthsClone = [...prevWidths];
      if (resizingColumnID !== -1) {
        resizeWidthsClone[resizingColumnID][state] = bool;
        if (newResizeWidth !== undefined) {
          resizeWidthsClone[resizingColumnID].width = newResizeWidth;
        }
      } else {
        resizeWidthsClone.push(_objectSpread({
          id,
          [state]: bool
        }, resizeWidth !== undefined && {
          width: newResizeWidth
        }));
      }
      return resizeWidthsClone;
    });
  }, [id, resizingColumnID, setResizeWidths]);
  var handleMouseMove = React.useCallback(event => {
    var _tableWrapperRef$curr, _tableWrapperRef$curr2, _tableWrapperRef$curr3;
    if (!tableWrapperRef.current) {
      return;
    }
    var eventClientX = event instanceof TouchEvent ? event.touches[0].clientX : event.clientX;
    setLineState('active');
    var tableOffset = (tableWrapperRef === null || tableWrapperRef === void 0 || (_tableWrapperRef$curr = tableWrapperRef.current) === null || _tableWrapperRef$curr === void 0 || (_tableWrapperRef$curr = _tableWrapperRef$curr.getBoundingClientRect()) === null || _tableWrapperRef$curr === void 0 ? void 0 : _tableWrapperRef$curr.left) || 0;
    var tableScrollLeft = (tableWrapperRef === null || tableWrapperRef === void 0 || (_tableWrapperRef$curr2 = tableWrapperRef.current) === null || _tableWrapperRef$curr2 === void 0 ? void 0 : _tableWrapperRef$curr2.scrollLeft) || 0;
    var offsetRight = window.innerWidth - tableWrapperRef.current.getBoundingClientRect().right;
    var newWidth = isRTL ? (((_tableWrapperRef$curr3 = tableWrapperRef.current.offsetParent) === null || _tableWrapperRef$curr3 === void 0 ? void 0 : _tableWrapperRef$curr3.getBoundingClientRect().right) || 0) - eventClientX - tableScrollLeft - Math.abs(headerOffset) - offsetRight + window.scrollX : eventClientX - headerOffset - tableOffset + tableScrollLeft;
    var minWidth = (minMaxWidth === null || minMaxWidth === void 0 ? void 0 : minMaxWidth.minWidth) || defaultMinWidth;
    var maxWidth = (minMaxWidth === null || minMaxWidth === void 0 ? void 0 : minMaxWidth.maxWidth) || Infinity;
    resizeWidth.current = newWidth;
    if (newWidth < minWidth) {
      resizeWidth.current = minWidth;
    }
    if (newWidth > maxWidth) {
      resizeWidth.current = maxWidth;
    }
    updateResizeWidths('isActive', true, resizeWidth.current);
    if (showResizeTooltip) {
      tooltipContent.current = Math.trunc(resizeWidth.current);
    }
    onResizeColumn === null || onResizeColumn === void 0 || onResizeColumn(id, resizeWidth.current);
    a11yAria.current.valueText = "".concat(resizeWidth, " px");
    if (minWidth !== defaultMinWidth) a11yAria.current.valueMin = "".concat(minWidth, " px");
    if ((maxWidth === null || maxWidth === void 0 ? void 0 : maxWidth.toString()) !== a11yAria.current.valueMax) a11yAria.current.valueMax = "".concat(maxWidth, " px");
  }, [defaultMinWidth, headerOffset, id, isRTL, minMaxWidth === null || minMaxWidth === void 0 ? void 0 : minMaxWidth.maxWidth, minMaxWidth === null || minMaxWidth === void 0 ? void 0 : minMaxWidth.minWidth, onResizeColumn, showResizeTooltip, tableWrapperRef, updateResizeWidths]);
  var handleMouseUp = React.useCallback(event => {
    if (event instanceof TouchEvent) {
      setLineState('default');
    } else {
      var _event$target;
      setLineState(event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.classList.contains('vn-resize-bar') ? 'hover' : 'default');
    }
    movementStarted.current = false;
    isColumnResizing.current = false;
    updateResizeWidths('isActive', false, resizeWidth.current);
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    document.removeEventListener('touchend', handleMouseUp);
    document.removeEventListener('touchmove', handleMouseMove);
  }, [handleMouseMove, isColumnResizing, resizeWidth, updateResizeWidths]);
  var handleMouseDown = React.useCallback(event => {
    setLineState('active');
    movementStarted.current = true;
    isColumnResizing.current = true;
    updateResizeWidths('isActive', true);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchend', handleMouseUp);
    document.addEventListener('touchmove', handleMouseMove);
    event.preventDefault();
  }, [handleMouseMove, handleMouseUp, isColumnResizing, updateResizeWidths]);
  var handleMouseEnter = React.useCallback(() => {
    if (!movementStarted.current) {
      setLineState('hover');
      updateResizeWidths('isHovered', true);
    }
  }, [updateResizeWidths]);
  var handleMouseLeave = React.useCallback(() => {
    if (!movementStarted.current) {
      setLineState('default');
      updateResizeWidths('isHovered', false);
    }
  }, [updateResizeWidths]);
  var tableHeadHeight = tableHeadRef === null || tableHeadRef === void 0 || (_tableHeadRef$current = tableHeadRef.current) === null || _tableHeadRef$current === void 0 ? void 0 : _tableHeadRef$current.offsetHeight;
  var tableBodyHeight = tableBodyRef === null || tableBodyRef === void 0 || (_tableBodyRef$current = tableBodyRef.current) === null || _tableBodyRef$current === void 0 ? void 0 : _tableBodyRef$current.offsetHeight;
  var style = useStyles({
    barHeight: tableHeadHeight,
    isActive: lineState === 'active',
    isHovered: lineState === 'hover',
    resizeLineHeight: tableBodyHeight,
    theme
  });
  var tooltipLabel = i18n.columnResizeTooltip.replace('%{columnWidth}', ((_tooltipContent$curre = tooltipContent.current) === null || _tooltipContent$curre === void 0 ? void 0 : _tooltipContent$curre.toString()) || (initialTooltipWidth === null || initialTooltipWidth === void 0 ? void 0 : initialTooltipWidth.toString()) || '');
  var resizeBar = ___EmotionJSX(Component, {
    "aria-orientation": "vertical",
    "aria-valuemax": a11yAria.current.valueMax,
    "aria-valuemin": a11yAria.current.valueMin,
    "aria-valuetext": a11yAria.current.valueText,
    css: showResizeTooltip ? style.showResizeTooltip : {},
    role: "separator"
  }, ___EmotionJSX("div", {
    className: "vn-resize-bar",
    css: style.bar,
    onMouseDown: handleMouseDown,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onTouchEnd: handleMouseLeave,
    onTouchStart: handleMouseDown,
    ref: ref,
    role: "button",
    tabIndex: -1
  }), ___EmotionJSX("div", {
    css: style.resizeLine
  }));
  var withTooltip = ___EmotionJSX(Tooltip, {
    content: ___EmotionJSX("span", {
      css: style.tooltip
    }, tooltipLabel),
    open: movementStarted.current,
    placement: "top-end",
    portal: true,
    useJsPositioning: true
  }, resizeBar);
  return showResizeTooltip ? withTooltip : resizeBar;
});
TableResizer.displayName = 'TableResizer';
export default TableResizer;